import { Button, styled, Typography } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import type { FC } from 'react';
import { useHubspotAuthRedirect } from '../../../../../../hooks/requests/use-hubspot-auth-redirect';
import { runMutation } from '../../../../../../utils/vy-mutation';

export const HubspotRegistration: FC = () => {
  const connectHubspotMutation = useHubspotAuthRedirect();

  const handleConnectClick = async () => {
    await runMutation(connectHubspotMutation, undefined, {
      pending: 'Connecting...',
      success: 'Redirecting...',
      error: 'Failed to connect',
    });
  };

  return (
    <FormContainer>
      <LogoContainer>
        <VyIcon
          icon="HubspotLogoIcon"
          style={{
            transform: 'scale(0.5)',
            transformOrigin: 'top left',
          }}
        />
      </LogoContainer>
      <Typography variant="h4">Connect to hubspot</Typography>
      <Typography variant="h6">Click here to authorize from hubspot</Typography>
      <Button onClick={handleConnectClick} variant="contained">
        Connect
      </Button>
    </FormContainer>
  );
};

const FormContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
});

const LogoContainer = styled('div')({
  width: 132,
  height: 132,
});
